var React = require('react');

function UiArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow Left"),React.createElement("path",{"d":"M1,16.1L16.1,1c1.3-1.3,3.4-1.3,4.7,0s1.3,3.4,0,4.7l0,0l-9.4,9.4h23.9c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3H11.4\n\tl9.4,9.4c1.3,1.3,1.3,3.4,0,4.7c-1.3,1.3-3.4,1.3-4.7,0L1,20.8C-0.3,19.5-0.3,17.4,1,16.1L1,16.1z","key":1})]);
}

UiArrowLeft.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 38.6 36.7","style":{"enableBackground":"new 0 0 38.6 36.7"},"xmlSpace":"preserve"};

module.exports = UiArrowLeft;

UiArrowLeft.default = UiArrowLeft;
